import React, { useContext, useEffect, useState } from "react";
import { ethers } from "ethers";
import { ProjectContext } from "../../ProjectContext";
import { useAccount } from "wagmi";
import { TfiReload } from "react-icons/tfi";

function EngineersTable() {
  const { account, esigner, settings, formatAddress, dbuser, copyaddress, Maincontract } = useContext(ProjectContext);
  const [Data, setData] = useState([]);
  const [selectedLevel, setSelectedLevel] = useState(0); // Track selected level as a number
  const { isConnected } = useAccount();
  const [Refaddress, setRefAddress] = useState(dbuser?.ref_address || ''); // Default to dbuser?.ref_address or empty string if not set

  // Utility function to format dates
  const formatDate = (timestamp) => {
    return new Date(timestamp * 1000).toLocaleString(); // Assuming timestamp is in seconds
  };

  // Fetch data based on selected level
  const getData = async () => {
    if (!isConnected || !settings.token || esigner === null || !settings.contract) return;

    // Call contract to fetch user data for the selected level
    const getUser = await Maincontract.getuserlevelteam(account, selectedLevel);
    console.log("Selected Level:", selectedLevel);
    console.log("getUser", getUser);

    // Ensure getUser is not empty
    if (!getUser || getUser.length === 0) {
      console.error("No user data found for address:", account);
      setData([]);  // Set an empty array if no data
      return;
    }

    // Fetch team data for each user
    const userTeamData = await Promise.all(
      getUser.map(async (userAddress) => {
        const getUserTeam = await Maincontract.users(userAddress);
        return {
          ref_address: getUserTeam[0],  // Address 1
          address: getUserTeam[1],  // Address 2
          stake: ethers.utils.formatUnits(getUserTeam[2], 6),  // Convert BigNumber to string
          date: formatDate(parseInt(getUserTeam[5]._hex, 16)),  // Convert _hex to timestamp
          packageexpire: new Date(Number(ethers.utils.formatUnits(getUserTeam[7], 6)) * 1000).toLocaleString(),
          status: Number(getUserTeam[7].toString()),  // Convert BigNumber to number
          level: selectedLevel,  // Save level as selected
        };
      })
    );

    console.log("Team user data:", userTeamData);
    setData(userTeamData);  // Set the state with the fetched data
  };

  // Handle level selection from the dropdown
  const handleLevelChange = (e) => {
    // Map dropdown value to the correct level
    const level = parseInt(e.target.value, 10); // Convert value to number
    console.log("Selected Level:", level); // Debugging: Check the selected level

    setSelectedLevel(level);  // Update the selected level state

    // Fetch data based on the selected level
    getData();
  };

  useEffect(() => {
    if (dbuser?.address.toLowerCase() === account?.toLowerCase()) {
      getData();
    }
  }, [dbuser, account, selectedLevel]);  // Ensure data is fetched on selected level change

  return (
    <div>
      <div className="mb-3 d-flex justify-content-between w-100">
        {/* Dropdown for selecting the level */}
        <label className="form-label text-white">Select Level</label>
        <select className="form-select dropdown" onChange={handleLevelChange} value={selectedLevel}>
          <option value="0">Level 1</option>
          <option value="1">Level 2</option>
          <option value="2">Level 3</option>
          <option value="3">Level 4</option>
          <option value="4">Level 5</option>
          <option value="5">Level 6</option>
        </select>
      </div>
      <table className="table">
        <tbody>
          <tr>
            <td className="text-end border-0" colSpan={4}>
              <button className="text-white btn btn-outline-bg-new-primary py-2 px-3" onClick={getData}>
                <TfiReload />
              </button>
            </td>
          </tr>
          <tr className="table-header">
            <th className="cell">S.NO</th>
            <th className="cell">ADDRESS</th>
            <th className="cell">AMOUNT</th>
            <th className="cell">LEVEL</th>
            <th className="cell">DATE</th>
            <th className="cell">STATUS</th>
          </tr>
          {Data.length > 0 ? (
            Data.map((user, index) => (
              <tr key={index}>
                <td><strong>{index + 1}</strong></td>
                <td>{formatAddress(user?.address)} <i className="fa fa-copy" onClick={() => copyaddress(user.address)}></i></td>
                <td>$ {user.stake}</td>
                <td>{user.level + 1}</td> {/* Display level as Level 1, Level 2, etc. */}
                <td>{user.date}</td>
                <td>
                  <span className={`badge light ${user?.status === 1 ? 'badge-success' : 'badge-danger'}`}>
                    {user?.status === 1 ? 'Active' : 'Inactive'}
                  </span>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="text-center">No data available</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default EngineersTable;
